import { v4 as uuidv4 } from 'uuid';
import { elementTypes } from '../utils/constants';

export const defaultBitmap = "data:image/png;base64,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";

export const EmptyContainer = () => (
    {
        id: uuidv4(),
        margin: "20px 0",
        rows: [
            {
                id: uuidv4(),
                margin: "5px 0",
                padding: "0",
                borderWidth: "0",
                roundedCorners: false,
                space: 5,
                columns: [
                    {
                        id: uuidv4(),
                        space: 3,
                        borderWidth: "0",
                        roundedCorners: false,
                        elements: [],
                    },
                ]
            },
        ],
    })

export const EmptyColumnTextLine = () => {
    return (
        {
            id: uuidv4(),
            type: elementTypes.textLine,
            property: "test",
            value: `New text line ${Math.floor(Math.random() * 1000)}`,
            layout: {
                order: 2,
            },
            text: {
                alignment: "left",
                fontFamily: "sans-serif",
                size: 18,
                bold: false,
                italic: false,
                underline: false,
                color: "#000",
            },
        }
    )
}

export const ContainerNew = () => {
    return (
        {
            id: uuidv4(),
            margin: "20px 0",
            rows: [
                {
                    id: uuidv4(),
                    margin: "5px 0",
                    padding: "0",
                    borderWidth: "0",
                    roundedCorners: false,
                    space: 5,
                    columns: [
                        {
                            id: uuidv4(),
                            space: 3,
                            borderWidth: "0",
                            roundedCorners: false,
                            elements: [
                                EmptyColumnTextLine()
                            ],
                        },
                    ]
                },
            ],
        })
};

export const ContainerEmpty = (element) => {
    return (
        {
            id: uuidv4(),
            margin: "20px 0",
            rows: [
                {
                    id: uuidv4(),
                    margin: "5px 0",
                    padding: "0",
                    borderWidth: "0",
                    roundedCorners: false,
                    space: 5,
                    columns: [
                        {
                            id: uuidv4(),
                            space: 3,
                            borderWidth: "0",
                            roundedCorners: false,
                            elements: [{ ...element, id: uuidv4() }],
                        },
                    ]
                },
            ],
        })
};

export const RowNew = () => {
    return ({
        id: uuidv4(),
        margin: "5px 0",
        padding: "0",
        borderWidth: "0",
        roundedCorners: true,
        space: 5,
        columns: [
            {
                id: uuidv4(),
                space: 3,
                borderWidth: "0",
                roundedCorners: false,
                elements: [
                    EmptyColumnTextLine()
                ],
            },
        ],
    })
};

export const ColumnNew = () => {
    return ({
        id: uuidv4(),
        space: 0,
        borderWidth: "0",
        roundedCorners: false,
        elements: [
            EmptyColumnTextLine()
        ],
    })
};

export const HeadLineNew = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.headerLine,
        property: "test",
        value: "New headline line",
        layout: {
            order: 2,
        },
        text: {
            level: '1',
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        },
    })
}

export const RadioButtonGroup = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.radioButtonGroup,
        property: "test",
        value: `Radio button ${Math.floor(Math.random() * 1000)}`,
        label: "Radio button",
        layout: {
            order: 2,
        },
        text: {
            level: '1',
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        },
    })
}

export const TextLineNew = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.textLine,
        property: "test",
        value: "New text line",
        layout: {
            order: 2,
        },
        text: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        },
    })
}


export const HyperLinkNew = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.hyperLink,
        label: "New HyperLink",
        value: "",
        layout: {
            order: 2,
        },
        isButton: false,
        text: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#1d29f0",
        },
    })
}

export const TextAreaNew = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.textArea,
        property: "test",
        value: "New text area",
        layout: {
            order: 2,
        },
        dependencies: {
            type: 0,
            value: 'none',
        },
        text: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        },
    })
}

export const InputTextLine = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.inputTextLine,
        property: "Input line",
        value: "New input text line",
        label: 'Label',
        backgroundColor: '#fff',
        borderColor: '#000',
        borderWidth: '1px',
        labelTop: true,
        layout: {
            order: 2,
        },
        dependencies: {
            type: 0,
            value: 'none',
        },
        text: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        },
        labelStyle: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 16,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        }
    })
}

export const Switch = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.switch,
        property: "Switch",
        value: 'false',
        label: 'switch',
        backgroundColor: '#000',
        borderWidth: '1px',
        layout: {
            order: 2,
        },
        text: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        },
    })
}

export const Checkbox = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.checkbox,
        property: "Checkbox",
        valueLabel: "Label",
        label: 'Description',
        backgroundColor: '#fff',
        borderWidth: '1px',
        layout: {
            order: 2,
        },
        defaultCheckedState: false,
        text: {
            level: null,
            alignment: 'left',
            fontFamily: 'arial',
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: '#000'
        },
        labelStyle: {
            level: null,
            alignment: 'left',
            fontFamily: 'arial',
            size: 16,
            bold: false,
            italic: false,
            underline: false,
            color: '#6b7281'
        },
    })
}

export const FileUpload = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.fileUpload,
        inputType: 2,
        property: 'file-upload',
        value: '',
        label: '',
        placeholder: '',
        margin: '30px 0 0 0',
        borderWidth: '1px',
        backgroundColor: '#fff',
        borderColor: '#e5e7eb',
        layout: {
            order: 2,
        },
        text: {
            alignment: 'center',
            fontFamily: 'sans-serif',
            size: 14,
            bold: false,
            italic: false,
            underline: false,
            color: 'black'
        }
    })
}

export const Divider = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.divider,
        borderWidth: '5px',
        borderColor: '#f0f0ef',
    })
}

export const Bitmap = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.bitmatp,
        property: "test",
        value: defaultBitmap,
        borderWidth: '0',
        width: 120,
        layout: {
            order: 2,
        },
        text: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        },
        bitmap: {
            round: false
        }
    })
}

export const Video = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.video,
        property: "test",
        value: "",
        borderWidth: '0',
        width: 500,
        layout: {
            order: 2,
        },
        video: {
            autoplay: false,
            type: 1,
        }
    })
}

export const InputTextArea = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.textArea,
        property: "Text area",
        value: "New input text area",
        label: 'Text area label',
        backgroundColor: '#fff',
        borderColor: '#000',
        borderWidth: '1px',
        dependencies: {
            type: 0,
            value: 'none',
        },
        layout: {
            order: 2,
        },
        text: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        },
        rows: 4,
        labelStyle: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        }
    })
}

export const Dropdown = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.dropDown,
        property: 'Drop down',
        width: 160,
        maxRows: 10,
        label: 'Dropdown label',
        borderColor: '#000',
        backgroundColor: '#fff',
        borderWidth: '1px',
        labelTop: true,
        text: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        },
        labelStyle: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        },
        dependencies: {
            type: 0,
            value: 'none',
        },
        options: [
            "Value 1",
            "Value 2",
            "Value 3",
            "Value 4"
        ],
        optionWithValues: [
            {
                id: uuidv4(),
                display: 'Value 1',
                description: 'Value 1',
                value: 'value1',
            },
            {
                id: uuidv4(),
                display: 'Value 2',
                description: 'Value 2',
                value: 'value2',
            },
            {
                id: uuidv4(),
                display: 'Value 3',
                description: 'Value 3',
                value: 'value3',
            },
            {
                id: uuidv4(),
                display: 'Value 4',
                description: 'Value 4',
                value: 'value4',
            },
        ],
        layout: {
            order: 5,
        },
    })
}

export const Button = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.button,
        backgroundColor: '#000',
        property: 'Buttton',
        value: 'Submit',
        borderWidth: '1px',
        layout: {
            order: 2,
        },
        text: {
            level: '1',
            alignment: 'left',
            fontFamily: 'arial',
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: '#fff'
        }
    })
}

export const CancelButton = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.cancelButton,
        backgroundColor: '#000',
        property: 'Clear button',
        value: 'Clear',
        borderWidth: '1px',
        layout: {
            order: 2,
        },
        text: {
            level: '1',
            alignment: 'left',
            fontFamily: 'arial',
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: '#fff'
        }
    })
}

export const Attachment = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.attachment,
        backgroundColor: '#000',
        property: 'attachment',
        label: 'new file',
        value: '',
        borderWidth: '1px',
        layout: {
            order: 2,
        },
        text: {
            level: '1',
            alignment: 'center',
            fontFamily: 'arial',
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: '#fff'
        }
    })
}

export const DatePicker = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.datePicker,
        inputType: 1,
        property: 'datepicker',
        label: 'Datepicker',
        placeholder: '',
        backgroundColor: '#fff',
        roundedCorners: false,
        borderWidth: '1px',
        borderColor: '#000',
        leadingText: '',
        trailingText: '',
        labelTop: true,
        width: 160,
        layout: {
            order: 2,
        },
        labelStyle: {
            alignment: 'left',
            fontFamily: 'arial',
            size: 14,
            bold: false,
            italic: false,
            underline: false,
            color: 'black'
        },
        text: {
            alignment: 'left',
            fontFamily: 'arial',
            size: 14,
            bold: false,
            italic: false,
            underline: false,
            color: 'black'
        }
    })
}

export const TimePicker = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.timePicker,
        inputType: 1,
        property: 'timerpicker',
        label: 'TimePicker',
        placeholder: '',
        backgroundColor: '#fff',
        roundedCorners: false,
        borderWidth: '1px',
        borderColor: '#000',
        leadingText: '',
        trailingText: '',
        labelTop: true,
        width: 260,
        layout: {
            order: 2,
        },
        labelStyle: {
            alignment: 'left',
            fontFamily: 'arial',
            size: 14,
            bold: false,
            italic: false,
            underline: false,
            color: 'black'
        },
        text: {
            alignment: 'left',
            fontFamily: 'arial',
            size: 14,
            bold: false,
            italic: false,
            underline: false,
            color: 'black'
        }
    })
}

export const RadioList = () => {
    return (
        {
            id: uuidv4(),
            type: elementTypes.radioList,
            property: "Radio list",
            borderWidth: '1px',
            backgroundColor: '#fff',
            layout: {
                order: 2,
            },
            optionWithValues: [
                {
                    id: uuidv4(),
                    display: "display",
                    description: "description",
                    value: "value"
                },
                {
                    id: uuidv4(),
                    display: "display",
                    description: "description",
                    value: "value"
                },
                {
                    id: uuidv4(),
                    display: "display",
                    description: "description",
                    value: "value"
                },
            ],
            text: {
                level: null,
                alignment: 'center',
                fontFamily: 'arial',
                size: 18,
                bold: false,
                italic: false,
                underline: false,
                color: '#000'
            },
            labelStyle: {
                level: null,
                alignment: 'center',
                fontFamily: 'arial',
                size: 16,
                bold: false,
                italic: false,
                underline: false,
                color: '#6b7281'
            },
        })
};

export const TableNew = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.table,
        inputType: 0,
        tableValues: [
            {
                id: uuidv4(),
                selectedValue: 'Select from dropdown',
                value: '0'
            },
            {
                id: uuidv4(),
                selectedValue: 'Select from dropdown',
                value: '0'
            },
            {
                id: uuidv4(),
                selectedValue: 'Select from dropdown',
                value: '0'
            },
            {
                id: uuidv4(),
                selectedValue: 'Select from dropdown',
                value: '0'
            }
        ],
        layout: {
            order: 5,
            right: false
        },
        text: {
            level: null,
            alignment: 'center',
            fontFamily: 'arial',
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: '#000'
        },
        labelStyle: {
            level: null,
            alignment: 'center',
            fontFamily: 'arial',
            size: 18,
            bold: false,
            italic: false,
            underline: false,
            color: '#000'
        },
        displayLabel: 'Display',
        valueLabel: 'Value',
        property: 'Table',
        value: null,
        borderWidth: '1px',
        borderColor: '#000',
        width: 160,
        label: null,
        leadingText: null,
        trailingText: '%',
        labelTop: false,
        backgroundColor: '#fff',
        roundedCorners: false,
        margin: null,
        leadingIcon: null,
        rows: null,
        flowOptions: null,
        maxFileSizeInMb: null,
        readOnly: false,
        maxRows: 10
    })
}


export const SignatureNew = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.signature,
        property: "Signature",
        value: "New signature",
        placeholder: "John Doe",
        label: 'Label',
        backgroundColor: '#fff',
        borderColor: '#000',
        borderWidth: '1px',
        height: 152,
        // labelTop: true,
        layout: {
            // order: 2,
        },
        labelStyle: {
            alignment: "left",
            fontFamily: "sans-serif",
            size: 16,
            bold: false,
            italic: false,
            underline: false,
            color: "#000",
        },
        text: {
            // alignment: "left",
            // fontFamily: "sans-serif",
            // size: 18,
            // bold: false,
            // italic: false,
            // underline: false,
            // color: "#000",
        },
    })
}


export const DynamicTable = () => {
    const columnId1 = uuidv4()
    const columnId2 = uuidv4()
    return ({
        id: uuidv4(),
        type: elementTypes.dynamicTable,
        property: "DynamicTable",
        roundedCorners: true,
        labelStyle: {
            color: "#6b7280",
            size: 12
        },
        text: {
            color: "#111827",
            size: 14,
        },
        dynamicTableValues: {
            columns: [
                {
                    title: "titulo 1",
                    id: columnId1,
                    width: 500,
                },
                {
                    title: "title 2",
                    id: columnId2,
                    width: 500,
                }
            ],
            rows: [
                {
                    value: "Value 1-1",
                    columnId: columnId1,
                    position: 1,
                },
                {
                    value: "Value 1-2",
                    columnId: columnId1,
                    position: 2,

                },
                {
                    value: "Value 1-3",
                    columnId: columnId1,
                    position: 3,
                },
                {
                    value: "Value 2-1",
                    columnId: columnId2,
                    position: 1,
                },
                {
                    value: "Value 2-2",
                    columnId: columnId2,
                    position: 2,
                },
                {
                    value: "Value 2-3",
                    columnId: columnId2,
                    position: 3,
                },
                {
                    value: "Value 1-4",
                    columnId: columnId1,
                    position: 4,
                },
                {
                    value: "Value 2-4",
                    columnId: columnId2,
                    position: 4,
                }
            ]
        }
    })
}

export const RichText = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.richText,
        property: "test",
        width: 500,
        height: 300,
        richTextValues: {
            contentInHtml: " "
        }
    })
}

export const DynamicList = () => {
    return ({
        id: uuidv4(),
        type: elementTypes.dynamicList,
        property: "test",
        value: "",
        labelStyle: {
            size: 12,
            color: "#616161"
        },
        text: {
            color: "#111827",
            size: 14,
        },
        dynamicListValues: {
            title: "Title Dynamic List",
            listValues: [
                {
                    position: 1,
                    value: "Value 1"
                },
                {
                    position: 2,
                    value: "Value 2"
                },
                {
                    position: 3,
                    value: "Value 3"
                },
            ]
        }
    })
}

export const Spacer = () => {
    return ({
        id: uuidv4(),
        property: "test",
        type: elementTypes.spacer,
        width: 10,
        height: 10
    })
}